import { extend } from "vee-validate";
import { required, email, min, integer, min_value, ext, max_value, size, excluded, confirmed } from "vee-validate/dist/rules";
import fileSizeFormatter from "@/utilities/file-size-formatter";

// No message specified.
extend("email", {
  ...email,
  validate(value) {
    const regexp= /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9]([a-zA-Z\-0-9]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}))$/
    return !!value.match(regexp)
  },
  message: "Неверный формат Email",
});

// Override the default message.
extend("required", {
  ...required,
  message: "Данное поле обязательно",
});

extend("excluded", {
  ...excluded,
  message: (text) => `Данное поле не должно быть пустым`,
});

extend("phone", {
  ...required,
  ...min,
  message: "Данное поле должно содержать не менее 11 символов",
});

extend('integer', {
  ...integer,
  message: 'Поле должно содержать целое число'
});

extend('ext', {
  ...ext,
  message: 'Неверный формат файлов'
});

extend('confirmed', {
  ...confirmed,
  message: 'Пароли должны совпадать'
});

extend('size', {
  ...size,
  message: (_, { size }) => `Файл(ы) превышают максимальный размер - ${fileSizeFormatter(size * 1024)}`
})

extend('password', {
  message: 'Пароль должен содержать 10 символов, строчные и прописные буквы латинского алфавита, спецсимволы.',
  validate: (value) => {
    return /[a-z]/.test(value) && /[A-Z]/.test(value) && /[0-9]/.test(value) && /[#?!@$%^&*\-._]/.test(value);
  }
})

extend('maxSize', {
  params: ['size'],
  validate(files, { size }) {
    const maxSizeVal = size
    let countSizes = 0
    if (isNaN(maxSizeVal)) {
      return false;
    }
    let nSize = maxSizeVal * 1024;
    if (!Array.isArray(files)) {
      return files.size <= nSize;
    }
    for (let i = 0; i < files.length; i++) {
      countSizes += files[i].size
    }
    return countSizes <= nSize;
  },
  message: (_, { size }) => `Макс. объем файлов для заявки ${fileSizeFormatter(size * 1000)}`
})

extend('min_value', {
  ...min_value,
  message: 'Поле должно быть больше {min}'
});

extend('max_value', {
  ...max_value,
  message: 'Поле должно быть меньше {max}'
});

extend("min", {
  ...min,
  message: "Данное поле должно содержать не менее {length} символов",
});

extend('phone_digits', {
  validate: (value) => {
    if (!value) return false;
    const digits = String(value).replace(/\D/g, '');
    return digits.length === 11;
  },
  message: 'Телефон должен содержать 11 цифр'
});